export const getMobileLineHeightClassName = (lineHeight) => `mlh-${lineHeight}`;
//# sourceMappingURL=get-mobile-line-height-class-name.js.map